import { Box } from "@ui/components/layout/box/Box";
import ProductInteractiveVideo from "./ProductInteractiveVideo";
import type { ImageWithVideo } from "@pages/product/[productName]/[articleNumber]/[colorCode]";
import { ProductVideo } from "./ProductVideo";
import { memo } from "react";

type ProductImagesVideoProps = {
    currentlySelected: boolean;
    image: ImageWithVideo;
};

export const ProductImagesVideo = memo(({ currentlySelected, image }: ProductImagesVideoProps) => {
    return (
        <Box
            opacity={currentlySelected ? 1 : 0}
            key={`product-video-${image.label}`}
            position="absolute"
            top={0}
            left={0}
            aspectRatio={"4/5"}
            w="100%"
            sx={{ transitionProperty: "common", transitionDuration: "slow" }}
            zIndex={currentlySelected ? 1 : 0}
        >
            {image.video720 ? (
                <ProductInteractiveVideo url={image.url} width={"100%"} />
            ) : (
                <ProductVideo productVideo={image.url} />
            )}
        </Box>
    );
});

ProductImagesVideo.displayName = "ProductImagesVideo";

export default ProductImagesVideo;
